import { ExtraType, GlassesType, LensPackType } from '@grandvision/products'

function isExtraActive(selectedExtras: ExtraType[], extra: ExtraType): boolean {
  return selectedExtras.indexOf(extra) > -1
}

export function getAllowedExtras(
  selectedGlasses: GlassesType,
  selectedLensPack: LensPackType,
  selectedExtras: ExtraType[]
): ExtraType[] {
  if (selectedLensPack === 'basic') {
    return []
  }

  const isMonofocal = selectedGlasses === 'frameAndMonofocal'

  if (selectedLensPack === 'bronze') {
    return isMonofocal
      ? ['manufactured-lenses', 'light-adaptive-pack']
      : ['manufactured-lenses', 'tinted-lenses-pack']
  } else if (selectedExtras.length === 0) {
    return isMonofocal
      ? [
          'tinted-lenses-pack',
          'manufactured-lenses',
          'polarized-pack',
          'personalized-pack',
          'light-adaptive-pack',
        ]
      : ['tinted-lenses-pack', 'manufactured-lenses', 'polarized-pack', 'light-adaptive-pack']
  } else {
    let extras: ExtraType[] = []
    if (isExtraActive(selectedExtras, 'light-adaptive-pack')) {
      extras = isMonofocal
        ? ['light-adaptive-pack', 'personalized-pack']
        : ['light-adaptive-pack', 'manufactured-lenses']

      // 'screen-protection-pack' is added here, but it is removed at the end
      if (
        isExtraActive(selectedExtras, 'personalized-pack') ||
        isExtraActive(selectedExtras, 'manufactured-lenses')
      ) {
        extras.push('screen-protection-pack')
      }
    } else if (isExtraActive(selectedExtras, 'polarized-pack')) {
      extras = isMonofocal
        ? ['polarized-pack', 'personalized-pack']
        : ['polarized-pack', 'manufactured-lenses']

      if (
        isExtraActive(selectedExtras, 'personalized-pack') ||
        isExtraActive(selectedExtras, 'manufactured-lenses')
      ) {
        extras.push('screen-protection-pack')
      }
    } else if (isExtraActive(selectedExtras, 'tinted-lenses-pack')) {
      extras = isMonofocal
        ? ['tinted-lenses-pack', 'personalized-pack']
        : ['tinted-lenses-pack', 'manufactured-lenses']

      if (
        isExtraActive(selectedExtras, 'personalized-pack') ||
        isExtraActive(selectedExtras, 'manufactured-lenses')
      ) {
        extras.push('screen-protection-pack')
      }
    } else {
      if (isExtraActive(selectedExtras, 'personalized-pack')) {
        extras = [
          'tinted-lenses-pack',
          'personalized-pack',
          'screen-protection-pack',
          'polarized-pack',
          'light-adaptive-pack',
        ]
      } else if (isExtraActive(selectedExtras, 'manufactured-lenses')) {
        extras = [
          'tinted-lenses-pack',
          'manufactured-lenses',
          'screen-protection-pack',
          'polarized-pack',
          'light-adaptive-pack',
        ]
      }
    }
    // Filter out 'screen-protection-pack' if not allowed
    if (
      isExtraActive(selectedExtras, 'screen-protection-pack') &&
      !isExtraActive(selectedExtras, 'personalized-pack') &&
      !isExtraActive(selectedExtras, 'manufactured-lenses')
    ) {
      extras = extras.filter((item) => item !== 'screen-protection-pack')
    }

    return extras
  }
}
